import axios from 'axios';

export const getAlertsApi = async ({ customerId, status } = {}) => {
  const response = await axios.get('/admin/alerts', {
    params: { customerId, status },
  });
  return response.data;
};

export const getAlertsSummaryApi = async () => {
  const response = await axios.get('/admin/alerts/summary');
  return response.data;
};

export const acknowledgeAlertApi = async ({ alertId }) => {
  const response = await axios.put(`/admin/alerts/${alertId}/acknowledge`);
  return response.data;
};

export const enableAccelerationApi = async ({ alertId }) => {
  const response = await axios.put(
    `/admin/alerts/${alertId}/enable-acceleration`
  );
  return response.data;
};

export const dismissAlertApi = async ({ alertId }) => {
  const response = await axios.put(`/admin/alerts/${alertId}/dismiss`);
  return response.data;
};
